import { buildURI } from '@hn-front/utils';
import { YEARLY_ROUTES } from './constants/routes';
import { Direction } from './types';
export var getStudentTimelineLinkBySupervizor = function (schoolId, teacherId, groupId, studentId) {
    return buildURI(YEARLY_ROUTES.teacherStudentTimeline, {
        pathParams: { groupId: groupId, studentId: studentId, schoolId: schoolId, teacherId: teacherId },
    });
};
export var getStudentTimelineLinkByTeacher = function (groupId, studentId) {
    return buildURI(YEARLY_ROUTES.teacherStudentTimeline, {
        pathParams: { groupId: groupId, studentId: studentId },
    });
};
export var compareRowsBySortField = function (a, b, direction) {
    if (a.startPoint === null ||
        a.startPoint === undefined ||
        b.startPoint === null ||
        b.startPoint === undefined)
        return 0;
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.startPoint < b.startPoint) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.startPoint > b.startPoint) {
        return 1 * d;
    }
    return 0;
};
export var compareRowsByProgressField = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.progress < b.progress) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.progress > b.progress) {
        return 1 * d;
    }
    return 0;
};
export var compareByRows = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.studentName.toLowerCase() < b.studentName.toLowerCase()) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.studentName.toLowerCase() > b.studentName.toLowerCase()) {
        return 1 * d;
    }
    return 0;
};
